import React, { useState } from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import { useNavigate } from "react-router-dom";
import { useModal } from "context/ModalContext";
import { useCallApi } from "api/apiHooks";
import { FormCard, MainBodyCard, PagesTitle } from "components/Cards";

export default function BrandForm(){
    let navigate = useNavigate()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchCreateBrand } = useCallApi()

    const [brandName, setBrandName] = useState('')
    
    // Button Event
    const saveBtnClick = async () => {
        if(!validation()) return 

        const onConfirm = await confirm()
        if (!onConfirm) return

        showLoading()

        try {
            const res = await fetchCreateBrand(brandName)
            if (!res) return

            showSuccess({
                onSuccess: () => {
                    navigate("/brand") 
                }
            })
        }
        finally {
            hideLoading()
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    const validation = () => {
        if (brandName === null || brandName === ''){
            showFail('Brand Name is required!')
            return false
        }

        return true
    }

    return(
        <MainBodyCard>
            <PagesTitle title='Brand Detail' />

            <div className="mt-5 flex flex-col gap-3 ">
                {/* Brand Name */}
                <div className="">
                    <FormCard title='Nama Brand'>
                        <input className="input" value={ brandName } onChange={(e) => { setBrandName(e.target.value.toUpperCase()) }} maxLength={40} />
                    </FormCard>
                </div>
            </div>
            
            {/* Button */}
            <div className="mt-5 flex flex-wrap justify-end gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <BackButton onClick={backBtnClick} />
            </div>
        </MainBodyCard>
    )
}